import { APP_TEXT } from '../const/app-text';
import { ProgressStatusType } from '../const/progress';

const text = APP_TEXT.components.resourceTable;


export const getLocationText = (isInternal: boolean, personalLogin: boolean): string => {
  if (isInternal) {
    return text.location.internal;
  } else {
    if (personalLogin) {
      return text.location.externalWithLogin;
    } else {
      return text.location.external;
    }
  }
};

export const locationCellTemplate = (isInternal: boolean, personalLogin: boolean): string => {
  return getLocationText(isInternal, personalLogin);
};

/**
 * Sorts resources by the given field and order. Handles categorical fields for skillLevel and userProgressStatus.
 * @param resources Array of resource objects to sort
 * @param sortField Field to sort by (e.g., 'skillLevel', 'userProgressStatus', etc.)
 * @param sortOrder 0 = no sort, 1 = ascending, 2 = descending
 */
export function sortResources(resources: any[], sortField: string, sortOrder: number): any[] {
  if (!sortField || sortOrder === 0) return resources;

  // Categorical rankings for custom fields
  const skillLevelRank: Record<string, number> = {
    Beginner: 1,
    Intermediate: 2,
    Advanced: 3,
  };
  const progressRank: Record<string, number> = {
    NOT_STARTED: 3,
    IN_PROGRESS: 2,
    COMPLETED: 1,
  };

  const sorted = [...resources].sort((a, b) => {
    let comparison = 0;
    if (sortField === 'skillLevel') {
      comparison =
        (skillLevelRank[a.skillLevel] ?? Number.MAX_SAFE_INTEGER) -
        (skillLevelRank[b.skillLevel] ?? Number.MAX_SAFE_INTEGER);
    } else if (sortField === 'userProgressStatus') {
      comparison =
        (progressRank[a.userProgressStatus] ?? Number.MAX_SAFE_INTEGER) -
        (progressRank[b.userProgressStatus] ?? Number.MAX_SAFE_INTEGER);
    } else {
      const left = String(a[sortField] ?? '').toLowerCase();
      const right = String(b[sortField] ?? '').toLowerCase();
      comparison = left.localeCompare(right);
    }
    return sortOrder === 2 ? comparison * -1 : comparison;
  });
  return sorted;
}

export const isProgressStatus = (value: string): value is ProgressStatusType => { 
  return (value as ProgressStatusType) !== undefined;
};